import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import NotificationItem from '@common/types/notifications/notification-item';
import { Action } from 'redux';
import { InviteStatus } from '../../../../../common/types/invites/invite-status';
import { PopupNotificationType } from './state';

export class ListNotifications implements LoadingAction {
  readonly type = actions.LIST_NOTIFICATIONS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public nextToken?: string) {}
}

export class ListNotificationsSuccess implements LoadingAction {
  readonly type = actions.LIST_NOTIFICATIONS_SUCCESS;
  readonly isLoading = false;

  constructor(public notifications: NotificationItem[]) {}
}

export class ListNotificationsError implements ErrorAction {
  readonly type = actions.LIST_NOTIFICATIONS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class MarkAsRead implements LoadingAction {
  readonly type = actions.MARK_AS_READ;
  readonly isLoading = true;
}

export class MarkAsReadSuccess implements LoadingAction {
  readonly type = actions.MARK_AS_READ_SUCCESS;
  readonly isLoading = false;
}

export class MarkAsReadError implements ErrorAction {
  readonly type = actions.MARK_AS_READ_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ClearNotifications implements LoadingAction {
  readonly type = actions.CLEAR_NOTIFICATIONS;
  readonly isLoading = true;

  constructor(public notificationId?: string) {}
}

export class ClearNotificationsSuccess implements LoadingAction {
  readonly type = actions.CLEAR_NOTIFICATIONS_SUCCESS;
  readonly isLoading = false;

  constructor(public notificationId?: string) {}
}

export class ClearNotificationsError implements ErrorAction {
  readonly type = actions.CLEAR_NOTIFICATIONS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateNotificationInvite implements Action {
  readonly type = actions.UPDATE_NOTIFICATION_INVITE_STATUS;

  constructor(public notificationId: string, public newStatus: InviteStatus) {}
}

export class SetPopupNotification implements Action {
  readonly type = actions.SET_POPUP_NOTIFICATION;

  constructor(public payload: PopupNotificationType) {}
}

export class AllNotificationsLoaded implements Action {
  readonly type = actions.ALL_NOTIFICATIONS_LOADED;
}

export type NotificationsActions =
  | ListNotifications
  | ListNotificationsSuccess
  | ListNotificationsError
  | MarkAsRead
  | MarkAsReadSuccess
  | MarkAsReadError
  | ClearNotifications
  | ClearNotificationsSuccess
  | ClearNotificationsError
  | UpdateNotificationInvite
  | SetPopupNotification
  | AllNotificationsLoaded;
